import CanceledPromiseError from "./CanceledPromiseError.js";
import TimeoutError from "./TimeoutError.js";
export class PromiseUtils {
  /**
   * Creates a promise that can be canceled by calling the `cancel` function
   * Pass an optional `cleanupFunc` to perform actions on the resolved item after promise is cancelled.
   * @param promise The item to resolve
   * @param cleanup Function to cleanup the resolved item after cancelation. Called after both this promise is cancelled and the wrapped item was resolved (order does not matter).
   */
  static makeCancelable(promise, cleanup) {
    var hasCanceled = false;
    var resolved;
    var rejectFn;
    var wrappedPromise = new Promise((resolve, reject) => {
      rejectFn = reject;
      Promise.resolve(promise).then(val => {
        if (hasCanceled) {
          if (cleanup) {
            cleanup(val);
          }
        } else {
          resolved = val;
          resolve(val);
        }
      }).catch(error => reject(error));
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    wrappedPromise.cancel = () => {
      hasCanceled = true;
      rejectFn(new CanceledPromiseError());
      if (resolved != null && cleanup) {
        cleanup(resolved);
      }
    };
    return wrappedPromise;
  }
  static isCanceled(error) {
    return error instanceof CanceledPromiseError;
  }
  static isTimedOut(error) {
    return error instanceof TimeoutError;
  }

  /**
   * Wrap a callback call in a Promise + setTimeout.
   * @param timeoutMs
   * @param callback
   */
  static withTimeout(timeoutMs, callback) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        try {
          resolve(callback());
        } catch (err) {
          reject(err);
        }
      }, timeoutMs);
    });
  }
}
//# sourceMappingURL=PromiseUtils.js.map